import { defineMessages } from 'react-intl';

export default defineMessages({
  UserAccessAprtmDirect: {
    defaultMessage: 'Access directly to the apartment allowed',
    id: 'user.access.aprtmDirect',
  },
  UserAccessBtnValidityEdit: {
    defaultMessage: 'Change validity',
    id: 'user.access.btnValidityEdit',
  },
  UserAccessNoValidityLimit: {
    defaultMessage: 'No limit',
    id: 'user.access.noValidityLimit',
  },
  UserAccessValidityEnd: {
    defaultMessage: '<typography>to</typography> {validityEnd} ',
    id: 'user.access.validityEnd',
  },
  UserAccessValidityLabel: {
    defaultMessage: 'Access validity',
    id: 'user.access.validityLabel',
  },
  UserAccessValidityStart: {
    defaultMessage: '<typography>from</typography> {validityStart}',
    id: 'user.access.validityStart',
  },
});
